export default __webpack_public_path__ + "static/media/userIcon.4f5be819.png";